import { GET_PLAN } from "./keys";

const initialState = {
    plans: [],
    eventStartDate: null,
    eventEndDate: null
}

export default function reducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case GET_PLAN: {
            const { planList, startDate, endDate } = payload;
            return { ...state, plans: planList, eventStartDate: startDate, eventEndDate: endDate };
        }

        default:
            return { ...state };
    }
}